import React from 'react'
import './style.css'


const SectionHeader = (props) => (
    <div className='section-header'>
        <div className='content-aligner'>
            { props.children }
        </div>
    </div>
)

export default SectionHeader
